<template>
	<div>
		<van-form>
			<van-field v-model="form.process_name" name="出差流程" label="出差流程" readonly />
			<van-field v-model="form.start_date" name="开始日期" label="开始日期" readonly />
			<van-field v-model="form.end_date" name="结束日期" label="结束日期" readonly />
			<van-field v-model="form.day" name="出差天" type="number" label="出差天" readonly />
			<van-field v-model="form.hour" name="出差小时" type="number" label="出差小时" readonly />
			<van-field v-model="form.minute" name="出差分钟" type="number" label="出差分钟" readonly />
			<van-field v-model="form.cause" rows="3" autosize label="请假事由" type="textarea" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "travel",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {}
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	}
};
</script>